<template>
	<div>
		<div class="container" v-if="!formData.disable_step_4">
			<div class="row">
				<div class="col-12 col-md-12 mb-4">
					<div class="disclaimer alert alert alert-danger mb-2 text-center">
						<span class="alert-circle-red d-flex align-self-start">
							Заполнив документы сейчас у вас есть возможность снизить риски связанные с оформлением и доступом к курсу в дальнейшем.
						</span>
						<button
							class="btn btn-link p-0"
							@click.prevent="$bvModal.show('documents-list')"
						>
							Читать пункты договора
						</button>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-md-6 col-lg-6">
					<div
						class="btn btn-block btn-primary btn-icon icon-plus mb-3"
						@click="formData.reverse_step_4 ? $emit('show-doc') : goToDocuments()"
					>
						Да, я готов(а) предоставить документы сейчас
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-6">
					<div
						class="btn btn-block btn-outline-primary btn-icon icon-time mb-3"
						@click="setContactManager(CONTACT_MANAGER_DO_NOT_WANT_SEND_DOCUMENTS)"
					>
						Нет, я сделаю это позже
					</div>
				</div>
			</div>
		</div>

		<b-modal size="lg" id="documents-list">
			<div class="d-block">
				<p>
					2.2.1. Для приема (зачисления) на обучение в Школу, зачисления на Программу и формирования личного дела Слушателя в соответствии с требованиями законодательства Российской Федерации Слушатель предоставляет Школе следующие документы:
				</p>
				<p>
				<ul>
					<li>- заявление о приеме на программу (электронная регистрация на Сайте);</li>
					<li>- документ, удостоверяющий личность (скан-, фотокопия разворота с ФИО);</li>
					<li>- документ о среднем профессиональном или высшем образовании (скан-, фотокопия) или документ, выданный в иностранном государстве и признаваемый эквивалентным российскому документу о среднем профессиональном или высшем образовании на основании международного соглашения Российской Федерации с государством, в котором выдан такой документ (ранее и далее документ об образовании);</li>
					<li>при получении Слушателем высшего или среднего профессионального образования на момент зачисления на Программу - справка из учебного заведения, подтверждающая получение Слушателем высшего или среднего профессионального образования на момент зачисления на Программу (копия). Копия документа об образовании предоставляется Слушателем Школы по факту его получения;</li>
					<li>- документ, подтверждающий смену фамилии (при необходимости).</li>
				</ul>
				</p>
				<p>
					2.2.2. Отсутствие документов, указанных в пункте 2.2.1., после начала Программы является основанием для расторжения Договора Школой в одностороннем внесудебном порядке. При этом в соответствии с Федеральным законом «Об образовании в Российской Федерации» удостоверение о повышении квалификации или диплом о профессиональной переподготовке не выдаётся, по запросу Слушателя ему может быть выдана справка об обучении или периоде обучения с указанием количества прослушанных часов.
				</p>
			</div>
			<template v-slot:modal-footer="{ ok }">
				<b-button size="sm" class="rounded-pill" variant="primary" @click="ok()">
					Закрыть
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import {
	ACTION_SAVE_FORM_DATA_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_META_DATA,
	MUTATION_SET_LOCAL_META_DATA,
} from '@/store/checkout';
import checkoutForm from '@/mixins/checkoutForm';
import { CONTACT_MANAGER_DO_NOT_WANT_SEND_DOCUMENTS } from './contactManagerReasonDictionary';

export default {
	name: 'DocumentInfoMessage',
	mixins: [checkoutForm],
	props: [
		'formData',
	],
	data() {
		return {
			CONTACT_MANAGER_DO_NOT_WANT_SEND_DOCUMENTS,
		};
	},
	methods: {
		goToDocuments() {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: { step: 4 },
					formId: this.formData.id,
				},
			);

			this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
				formId: this.formData.id,
				localMeta: {
					isShowDocumentInfoMessage: false,
				},
			});

			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);
		},
	},
};
</script>

<style scoped>

</style>
